// extracted by mini-css-extract-plugin
export default {"parent":"lead_parent__qeOX1","lead":"lead_lead__EAUPL","container":"lead_container__KAz5h","content":"lead_content__Zkr4R"};